export default __webpack_public_path__ + "static/card-friends-1-cfa0b274772722fa528df44211c5f62c.png";